class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ============================================================
   Float House: cart drawer fix + Nitro 3 free 4-pack redeem
   Updated 2026-06-24 for the Nitro 3 clearance promo.
   (1) Restores the cart drawer open state store-wide.
   (2) On /pages/free-nitro, silently adds the Nitro 3 4-pack and
       updates the cart count. The hero landing is the focus, so the
       drawer does NOT auto-open. window.fhOpenNitroCart() opens the
       populated drawer on demand (the secondary CTA calls it).
   ============================================================ */
(function () {
  try {
    var fix = document.createElement('style');
    fix.id = 'fh-cart-drawer-fix';
    fix.textContent =
      'cart-drawer.active{visibility:visible !important;transition:none !important}' +
      'cart-drawer.active .drawer__inner{transform:translate(0) !important}';
    (document.head || document.documentElement).appendChild(fix);
  } catch (e) {}

  var REDEEM_PATH = '/pages/free-nitro';
  var VARIANT_ID = 43814649462893; // THC Nitro 3mg / 4pk

  function onRedeemPage() {
    return window.location.pathname.replace(/\/+$/, '') === REDEEM_PATH;
  }

  function replaceSection(sectionHtml, hostSelector) {
    try {
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var fresh = doc.querySelector(hostSelector);
      var live = document.querySelector(hostSelector);
      if (fresh && live) live.innerHTML = fresh.innerHTML;
    } catch (e) {}
  }

  function updateBubble() {
    return fetch('/?sections=cart-icon-bubble', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) { replaceSection(s['cart-icon-bubble'], '#cart-icon-bubble'); })
      .catch(function () {});
  }

  // Open the cart drawer with fresh contents (used by the hero secondary CTA)
  window.fhOpenNitroCart = function () {
    fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var d = document.querySelector('cart-drawer');
        if (!d) { window.location = '/cart'; return; }
        d.classList.remove('is-empty');
        if (typeof d.renderContents === 'function') {
          d.renderContents({ sections: sections });
        } else if (typeof d.open === 'function') {
          d.open();
        }
      })
      .catch(function () {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') d.open();
        else window.location = '/cart';
      });
    return false;
  };

  function run() {
    if (!onRedeemPage()) return;
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var has = (cart.items || []).some(function (i) { return i.id === VARIANT_ID || i.variant_id === VARIANT_ID; });
        if (has) { return updateBubble(); }
        return fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] })
        }).then(function () { return updateBubble(); });
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
